import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loggerFor } from '@app/utils/logger';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

export enum HttpProgressEventType {
  Start,
  Progress,
  Done,
}

export class DownloadProgressEvent {
  type: HttpProgressEventType = HttpProgressEventType.Start;
  done: number = 0;
  data?: Blob;
  fileName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  constructor(private http: HttpClient) {}

  private logger = loggerFor('FileDownloadService');

  download(url: string): Observable<DownloadProgressEvent> {
    let subject = new Subject<DownloadProgressEvent>();

    // let a, config, deferred, urlParams, vendor
    // if (params == null) {
    //   params = null
    // }
    // urlParams = this.getUrlParamsAsStringFromObject(params)
    // config = {
    //   method: 'GET',
    //   url: url + urlParams,
    //   responseType: 'arraybuffer'
    // }
    let downloadProgressEvent = new DownloadProgressEvent();
    // let vendor = window.navigator.vendor != null ? window.navigator.vendor : ''
    // if (vendor.indexOf('Apple') !== -1 || window.navigator.msSaveBlob) {
    //   let a = document.createElement('a')
    //   a.href = url //+ urlParams
    //   document.body.appendChild(a)
    //   a.click()
    //   setTimeout(() => {
    //     document.body.removeChild(a)
    //     // response: 'The file will be downloaded shortly!',
    //     downloadProgressEvent.type = HttpProgressEventType.Done
    //     subject.next(downloadProgressEvent)
    //     return subject.complete()
    //   }, 0)
    //   return subject
    // } else {
    const req = new HttpRequest('GET', url, {
      reportProgress: true,
      responseType: 'blob',
    });

    return this.http.request(req).pipe(
      map((event: HttpEvent<Blob>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.logger.debug('Request sent!');
            break;
          case HttpEventType.ResponseHeader:
            this.logger.debug('Response headers received!', event.headers);
            let fileName = this.getFileNameFromHeader(event.headers);
            downloadProgressEvent.fileName = fileName;
            break;
          // case HttpEventType.UploadProgress:
          //   const percentUploaded = Math.round((100 * event.loaded) / event.total)
          //   this.logger.debug(`File is ${percentUploaded}% uploaded.`)
          //   break
          case HttpEventType.DownloadProgress:
            const kbLoaded = Math.round(event.loaded / 1024);
            const kbTotal = Math.round(event.total / 1024);
            const percentDownloaded = Math.round((100 * event.loaded) / event.total);
            this.logger.debug(
              `Download in progress! ${kbLoaded}KB/${kbTotal}KB loaded (${percentDownloaded}%)`
            );
            downloadProgressEvent.type = HttpProgressEventType.Progress;
            downloadProgressEvent.done = percentDownloaded;
            break;
          case HttpEventType.Response:
            this.logger.debug('Done!', event.body);
            downloadProgressEvent.type = HttpProgressEventType.Done;
            downloadProgressEvent.done = 100;
            downloadProgressEvent.data = event.body;
            break;
          default:
            this.logger.warn('Unknown HttpEventType', event);
        }
        this.logger.debug('HttpEvent', event, 'DownloadProgressEvent', downloadProgressEvent);
        return downloadProgressEvent;
      })
    );
    // }
  }

  private arrayBufferToString(buffer) {
    let charCodeArray;
    let result;
    charCodeArray = Array.apply(null, new Uint8Array(buffer));
    result = '';
    charCodeArray.forEach((code) => {
      return (result += String.fromCharCode(code));
    });
    this.logger.debug('convertArrayBufferToString:', result);
    return result;
  }

  private getFileNameFromHeader(headers: HttpHeaders) {
    let fileName = 'download';
    const cdHeader = headers.get('content-disposition');
    if (cdHeader) {
      const extraction = cdHeader.match(/filename=\"?([^"]*)/);
      if (extraction) {
        fileName = extraction[1] !== undefined ? extraction[1] : fileName;
      }
      this.logger.debug('header', cdHeader);
      this.logger.debug('fileName ', fileName);
    }
    return fileName;
  }

  private getUrlParamsAsStringFromObject(params) {
    if (params != null) {
      return (
        '?' +
        Object.keys(params)
          .map((k) => {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
          })
          .join('&')
      );
    } else {
      return '';
    }
  }
}
